import { Popover } from "antd";
import React from "react";

import CoverIcon from "../../../../../Icons/CoverIcon";

const CoverColleagueTag = ({
  proposed_candidate_name = "",
  proposed_contract_ref = "",
  hoverType = "shift", // Default to "shift" message
  textVisible = true,
}) => {
  const containerClasses = `
        flex items-center gap-2 rounded-[4px] px-2 py-1 text-center font-medium leading-[23px] 
        h-[27px] w-[80px] bg-lightOrange text-darkOrange cursor-pointer
    `;
  const icon = <CoverIcon cls="text-darkOrange" />;
  const text = "Cover";
  const textSize = "text-[12px] text-darkOrange";

  // Dynamic tooltip message based on hoverType
  const tooltipMessages = {
    shift: (
      <span>
        This shift was originally booked by{" "}
        <strong>{proposed_candidate_name} </strong>(
        <strong>{proposed_contract_ref}</strong>), now open for cover.
      </span>
    ),
    application: (
      <span>
        This application is for a cover shift originally held by{" "}
        <strong>{proposed_candidate_name}</strong>(
        <strong>{proposed_contract_ref}</strong>).
      </span>
    ),
  };

  return (
    <Popover
      content={
        <div className="max-w-[265px] p-2">
          <p className="p-2 text-[14px] font-medium leading-[1.7]">
            {tooltipMessages[hoverType]}
          </p>
        </div>
      }
      rootClassName="z-[1033]"
    >
      <div className={containerClasses}>
        {icon}
        <span className={textSize}>{text}</span>
      </div>
    </Popover>
  );
};

export default CoverColleagueTag;
